import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getTimezoneOffset } from '@dss-libs/shared/utility/common-utilities';

export function timezoneOffsetInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const timezoneOffset = getTimezoneOffset();

  const clonedRequest = req.clone({
    setHeaders: {
      'X-DSS-TimezoneOffset': timezoneOffset,
    },
  });

  return next(clonedRequest);
}
